import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right-active",
  "use": "icon-arrow-right-active-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-arrow-right-active\"><g fill-rule=\"nonzero\" fill=\"none\"><rect fill=\"#236CFF\" width=\"16\" height=\"16\" rx=\"4\" /><path fill=\"#FFF\" d=\"m6.796 12.354-.707-.707L9.735 8 6.089 4.354l.706-.708L11.15 8z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol